import React from 'react';
import ReactPlayer from 'react-player';

import Icon from '../Icon/Icon';
import * as styles from './Video.module.scss';

const PlayIcon = () => (
  <button className={styles.button} type="button" aria-label="Play video">
    <Icon name="play" />
  </button>
);

const Video = ({ caption, ...other }) => {
  return (
    <figure className={styles.container}>
      <div className={styles.video}>
        <ReactPlayer
          {...other}
          className={styles.player}
          playIcon={<PlayIcon />}
          light
          playing
          width="100%"
          height="100%"
          controls={true}
        />
      </div>
      
      {caption &&
        <figcaption className={styles.caption}>
          <Icon name="video" />
          {caption}
        </figcaption>
      }
    </figure>
  );
};

export default Video;
